import React from 'react';

const GerIndicador2 = props => {
  let resolucionPantalla = {
    ancho: window.screen.width,
    alto: window.screen.height
  };
  
  let ancho=resolucionPantalla.ancho*0.95
  let alto=resolucionPantalla.alto*0.95
  return (
    <div>
      <iframe width={ancho} height={alto} src="https://lookerstudio.google.com/embed/reporting/e4839bb9-dccd-46f1-8907-a3707da76765/page/t5vSD"></iframe>
    </div>
  )
}

export default GerIndicador2